import { render, staticRenderFns } from "./sw-logo.vue?vue&type=template&id=64f63787&"
import script from "./sw-logo.vue?vue&type=script&lang=js&"
export * from "./sw-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports